import React, { FC, useEffect } from 'react'
import IPresentationPageProps from 'interfaces/IPresentationPageProps'
import Presentation from 'models/Presentation'
import { observer, inject } from 'mobx-react'
import { useHistory } from 'react-router-dom'
import Modal from 'components/Modal'
import Spinner from 'components/Spinner'
import styled from 'styled-components'
import Video from 'components/Video'
import Login from 'models/Login'
import UserStatusType from 'consts/UserStatusType'

const SpinnerStyled = styled(Spinner)`
  margin: 26px 0;
`

export const PresentationEnd:FC<IPresentationPageProps> = ({presentation = new Presentation(), loginInfo = new Login()})=>{
  const history = useHistory();

  const uploadRecords = async () => {
    try {
      await presentation.uploadRecords();
      await loginInfo.updateUserStatusType(UserStatusType.COMPLETED);
      history.replace('/finale');
    } catch(e){
      console.error(e);
      if(e.response?.status === 400) {
        presentation.isError = true;
        presentation.ErrorMsg = e.response?.data?.message || '최대 응시 가능횟수를 초과하여 재응시가 제한됩니다.';
      }
      presentation.uploading = false;
    }
  }
  useEffect(() => {
    uploadRecords();
  }, []);

  return (
    <Modal
      open={true}
      dim={true}
    >
      <div>
        {
          presentation.uploading?
          `영상을 업로드중입니다. 잠시만 기다려주세요.`
          :
          presentation.isError ? 
          presentation.ErrorMsg
          :
          `재시도 해주세요.`
        }
      </div>
      {
        process.env.REACT_APP_ENV === 'development' && 
        <div>
          <div>전송될기록: {presentation.history.length}</div>
          <div>
            {JSON.stringify(presentation.history)}
          </div>
        </div>
      }
      {
        process.env.REACT_APP_ENV === 'development' && 
        presentation.finalVideoUrl &&
        <div>
          <Video autoPlay src={presentation.finalVideoUrl} />
        </div>
      }
      {
        presentation.uploading?
        <SpinnerStyled/>
        :
        presentation.isError ?
        <button className='btn-cta' onClick={()=>{
          loginInfo.logout();
          history.replace('/login');
        }}>
          확인
        </button>
        :
        <button className='btn-cta' onClick={()=>uploadRecords()}>
          재시도
        </button>
      }
    </Modal>
  );
}

export default inject('presentation', 'loginInfo')(observer(PresentationEnd));